<div class="main">
    <div class="main-context">
        <div class="main-context-heading">
            <fui-page-header-heading [description]="description | translate"
                                     [title]="title | translate"></fui-page-header-heading>
        </div>
        <div class="main-context-nav" *ngIf="pageHeaderNav">
            <ng-content select="fui-page-header-nav"></ng-content>
        </div>
        <div class="main-context-toggle">
            <fui-section-toggle *ngIf="hasToggle" [toggled]="toggled" (toggled$)="toggle($event)"></fui-section-toggle>
        </div>
    </div>
    <div class="main-content" *ngIf="toggled">
        <ng-content></ng-content>
    </div>
</div>
<div class="breadcrumbs" *ngIf="breadcrumbs">
    <ng-content select="fui-breadcrumbs"></ng-content>
</div>
